import React, { useEffect } from 'react';
import AppointmentScheduler from '../components/sections/AppointmentScheduler';
import GetInTouch from '../components/sections/GetInTouch'
import InnerPageHero from '../components/sections/InnerPageHero'
import { FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function Appointment() {

   const navigate = useNavigate();
   
     // Scroll to top when the component mounts
     useEffect(() => {
       console.log('Contact: Scrolling to top');
       // Immediate scroll
       window.scrollTo({ top: 0, behavior: 'instant' });
       // Fallback scroll after slight delay to handle rendering
       const timer = setTimeout(() => {
         window.scrollTo({ top: 0, behavior: 'instant' });
       }, 100);
       return () => clearTimeout(timer);
     }, []);
  return (
    <div className="app-container">
      {/* <main className="main-content"> */}
      <InnerPageHero 
      title="Appointments"
        breadcrumbs={[
          { label: 'Home', href: '/', icon: FaHome ,onClick: () => navigate('/')},
          { label: 'Appointments', isCurrentPage: true }
        ]} />
        <AppointmentScheduler />
      <GetInTouch />
    </div>
  )
}

export default Appointment
